import {Layout} from "antd";
import {Outlet} from "react-router-dom";

export const PublicLayout = () => {
  return (
    <Layout.Content style={{overflowY: 'scroll', overflowX: 'hidden', scrollBehavior: 'smooth', backgroundColor: '#FCF8F1', padding: '24px 0',paddingBottom: '0', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
      <Outlet/>
    </Layout.Content>
  )
}